<template>
    <van-popup v-model:show="show" position="center" round :style="popupStyle">
        <div class="rating-popup">
            <div class="close-btn" @click="handleClose">
                <img src="@/assets/images/message/close.svg" class="w-24px h-24px" alt="close" />
            </div>
            <div class="w-200px h-139px mt-20px">
               <img src="@/assets/images/chat/chatRecord/ad.webp" class="w-100% h-100%" alt="not_ads" />
            </div>
            <div class="text-24px font-800 mt-15px">
                No Ads!
            </div>
            <div class="mt-15px text-12px color-#fff">
                Enjoy a clean, ad-free experience. Your trial is ready.
            </div>
            <div class="w-100% flex items-center justify-around gap-10px mt-20px">
                    <div class="text-14px font-500 leave">
                        Leave
                    </div>
                    <div class="text-14px font-500 chatting">
                        Get now
                    </div>
                </div>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const show = defineModel<boolean>('show', {
    required: true
})

const popupStyle = computed(() => ({
    width: '90%',
    maxWidth: '520px',
    background: '#1B1E33',
    borderRadius: '20px'
}))

const handleClose = () => {
    show.value = false
}
</script>

<style scoped lang="scss">
.rating-popup {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 32px 24px 24px;
    .close-btn{
        position: absolute;
        top: 10px;
        right: 10px;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 1000;
    }
    .leave{
        border-radius: 23px;
        border: 1px solid #61636E;
        padding: 8px 18px;
    }
    .chatting{
        background: linear-gradient( 0deg, #5A68FF 0%, #95A5FF 100%);
        padding: 8px 52px;
        border-radius: 23px;

    }
}
</style>